export const SITE = {
  name: "Patrick's Bar",
  locationLabel: 'Upper Bangor, North Wales',
  address: {
    street: '57–59 Holyhead Road',
    town: 'Bangor',
    postcode: 'LL57 2HE',
  },
  social: {
    facebook: 'https://www.facebook.com/patricksbar.comno1',
    instagram: 'https://www.instagram.com/patricksbar.comno1/',
  },
  mapUrl:
    'https://www.google.com/maps/search/?api=1&query=57-59%20Holyhead%20Road%2C%20Bangor%2C%20LL57%202HE',
  mapEmbedUrl:
    'https://maps.google.com/maps?width=900&height=560&hl=en&q=57-59%20Holyhead%20Road%20Bangor%20LL57%202HE+(Patrick%27s%20Bar)&t=&z=15&ie=UTF8&iwloc=B&output=embed',
  webcamUrl:
    process.env.REACT_APP_WEBCAM_URL || 'http://81.137.218.242:8080/cam_1.jpg',
};

// These are the opening times already published by the existing website.
// Confirm them with the venue before changing or redeploying.
export const OPENING_HOURS = [
  { day: 'Monday', dayIndex: 1, hours: '11:00am – 2:00am' },
  { day: 'Tuesday', dayIndex: 2, hours: '11:00am – 2:00am' },
  { day: 'Wednesday', dayIndex: 3, hours: '11:00am – 2:30am' },
  { day: 'Thursday', dayIndex: 4, hours: '11:00am – 2:00am' },
  { day: 'Friday', dayIndex: 5, hours: '11:00am – 3:00am' },
  { day: 'Saturday', dayIndex: 6, hours: '11:00am – 3:00am' },
  { day: 'Sunday', dayIndex: 0, hours: '11:00am – 2:00am' },
];
